module.exports = __webpack_public_path__ + "media/theme/collection__mobage-a6ccb0d4.png";